<script>
    let cls = "sui-tag";
</script>

<style lang="less">
    @import "./tag.less";
</style>

<span
    class={`${cls} ${$$props.class || ""}`}><slot /></span>